module.exports = __webpack_public_path__ + "static/media/ET_Leadership_excellence_Award.ce6d0454.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ET_Leadership_excellence_Award.webp
// module id = 342
// module chunks = 0